'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ListEditor = require('./components/ListEditor.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ListEditor).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/user-list/lib/components/list-editor/index.js
// module id = 1042
// module chunks = 0